module.exports = __webpack_public_path__ + "media/theme/icon__mail-eba8f264.png";